import axios from "axios";
import Globals from "../Globals";
import LoggingService from "./LoggingService";
import { getLogModel } from "../Functions";
import VehicleDetails from "components/auctions/ModalDetailVehicle/VehicleDetails";

class TransportService {
  base_url = Globals.BFF_PATH.BASE_URL + Globals.BFF_PATH.TRANSPORT.BASE_PATH;

  getTransportPrice = async (token, object) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    const data = {
      headers: {
        Authorization: `${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(object),
    };
    return await axios
      .post(this.base_url + Globals.BFF_PATH.TRANSPORT.GET_PRICE, data, config)
      .then((response) => {
        if (response && response.data && response.data.body) {
          response.data.body = JSON.parse(response.data.body);
        }
        return response.data.body;
      })
      .catch(function (error) {
        var newError = getLogModel(
          Globals.ERROR_LOG_ID,
          error.config.url,
          config,
          data,
          error
        );
        new LoggingService().createLog(newError);
      });
  };

  getCodeProvince = async (token, value) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    const data = {
      headers: {
        Authorization: `${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(value),
    };

    return await axios
      .post(
        this.base_url + Globals.BFF_PATH.TRANSPORT.GET_PROVINCE_CODE,
        data,
        config
      )
      .then((response) => {
        if (response && response.data && response.data.body) {
          response.data.body = JSON.parse(response.data.body);
        }
        return response.data.body;
      })
      .catch(function (error) {
        var newError = getLogModel(
          Globals.ERROR_LOG_ID,
          error.config.url,
          config,
          data,
          error
        );
        new LoggingService().createLog(newError);
      });
  };

  GetdataConsesionarie = async (token, Cif) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    const data = {
      headers: {
        Authorization: `${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(Cif),
    };
    return await axios
      .post(
        this.base_url + Globals.BFF_PATH.TRANSPORT.GET_DEALER_DATA,
        data,
        config
      )
      .then((response) => {
        if (response && response.data && response.data.body) {
          response.data.body = JSON.parse(response.data.body);
        }
        return response.data;
      })
      .catch(function (error) {
        var newError = getLogModel(
          Globals.ERROR_LOG_ID,
          error.config.url,
          config,
          data,
          error
        );
        new LoggingService().createLog(newError);
      });
  };

  getPoblationByCodeZip = async (token, Cp) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    const data = {
      headers: {
        Authorization: `${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(Cp),
    };
    return await axios
      .post(
        this.base_url + Globals.BFF_PATH.TRANSPORT.GET_POBLATION,
        data,
        config
      )
      .then((response) => {
        if (response && response.data && response.data.body) {
          response.data.body = JSON.parse(response.data.body);
        }
        return response.data;
      })
      .catch(function (error) {
        var newError = getLogModel(
          Globals.ERROR_LOG_ID,
          error.config.url,
          config,
          data,
          error
        );
        new LoggingService().createLog(newError);
      });
  };

  getStreetType = async (token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    const data = {
      headers: {
        Authorization: `${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    return await axios
      .post(
        this.base_url + Globals.BFF_PATH.TRANSPORT.GET_STREET_TYPE,
        data,
        config
      )
      .then((response) => {
        if (response && response.data && response.data.body) {
          response.data.body = JSON.parse(response.data.body);
        }
        return response.data;
      })
      .catch(function (error) {
        var newError = getLogModel(
          Globals.ERROR_LOG_ID,
          error.config.url,
          config,
          data,
          error
        );
        new LoggingService().createLog(newError);
      });
  };

  getBranchEstadistics = async (token, object) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    const data = {
      headers: {
        Authorization: `${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(object),
    };
    return await axios
      .post(
        this.base_url + Globals.BFF_PATH.TRANSPORT.GET_BRAND_STATISTICS,
        data,
        config
      )
      .then((response) => {
        if (response && response.data && response.data.body) {
          response.data.body = JSON.parse(response.data.body);
        }
        return response.data;
      })
      .catch(function (error) {
        var newError = getLogModel(
          Globals.ERROR_LOG_ID,
          error.config.url,
          config,
          data,
          error
        );
        new LoggingService().createLog(newError);
      });
  };

  GetDataSolicitudeTransportByVehicleId = async (token, value) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    const data = {
      headers: {
        Authorization: `${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(value),
    };
    return await axios
      .post(this.base_url + Globals.BFF_PATH.TRANSPORT.GET, data, config)
      .then((response) => {
        if (response && response.data && response.data.body) {
          response.data.body = JSON.parse(response.data.body);
        }
        return response.data.body;
      })
      .catch(function (error) {
        var newError = getLogModel(
          Globals.ERROR_LOG_ID,
          error.config.url,
          config,
          data,
          error
        );
        new LoggingService().createLog(newError);
      });
  };

  DownloadProformaPDF = async (token, object) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      ErrorCode: Globals.ERROR_CODE
    }
  };

  const data = {
    headers: {
      Authorization: token,
      ErrorCode: Globals.ERROR_CODE
    },
    body: JSON.stringify(object)
  };
  return await axios
    .post(
      this.base_url + Globals.BFF_PATH.TRANSPORT.GET_PROFORMA,
      data,
      config
    )
    .then(response => {

      const parsedBody = JSON.parse(response.data.body);
      const base64Pdf = parsedBody.Result;

      const byteCharacters = window.atob(base64Pdf);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = fileURL;
      a.download = object.TransportRequest.VehicleId + `_Proforma.pdf`;
      a.click();
     
    })
    .catch(error => {
      var newError = getLogModel(
        Globals.ERROR_LOG_ID,
        error.config.url,
        config,
        data,
        error
      );
      new LoggingService().createLog(newError);
      throw error;
    });
};


  UpdateDataTransportSolicitude = async (token, object) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    const data = {
      headers: {
        Authorization: `${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(object),
    };
    return await axios
      .post(this.base_url + Globals.BFF_PATH.TRANSPORT.UPDATE, data, config)
      .then((response) => {
        if (response && response.data && response.data.body) {
          response.data.body = JSON.parse(response.data.body);
        }
        return response.data.body;
      })
      .catch(function (error) {
        var newError = getLogModel(
          Globals.ERROR_LOG_ID,
          error.config.url,
          config,
          data,
          error
        );
        new LoggingService().createLog(newError);
      });
  };
}
export default TransportService;
